class FlyNoWay {
  fly() {
    //Don't do nothing.
  }
}

export default FlyNoWay;
